import React from 'react';
import { GuideAppContainer, PageContainer } from '@ignitesales/neuro-application/src/neuro-guide';
//import {useToastNofitications} from '@ignitesales/neuro-application/src/neuro-guide/components/ToastNotifications';
import LandingPage from './components/pages/LandingPage';
import SurveyPage from './components/pages/SurveyPage';
import SummaryPage from './components/pages/SummaryPage';
import DetailsPage from './components/pages/DetailsPage';
// import PageNavigation from './components/PageNavigation';
import Header from './components/Header';


const App = () => {

  return <GuideAppContainer>
    <Header/>
    <PageContainer
      LandingPage={LandingPage}
      SurveyPage={SurveyPage}
      SummaryPage={SummaryPage}
      DetailsPage={DetailsPage}
      transitionTimeout={1}
    />
  </GuideAppContainer>;
};

export default App;
